module.exports = __webpack_public_path__ + "static/media/popsy.de985329.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/carousel/popsy.png
 ** module id = 422
 ** module chunks = 0
 **/